export const KCI_WEB_LOCATION_ID = '97';
export const FORTY_EIGHTH_STREET_LOCATION_ID = '8';
export const MIAMI_LOCATION_ID = '16';
export const LOS_ANGELES_LOCATION_ID = '73';
export const LONDON_LOCATION_ID = '144';
export const EUROPE_LOCATION_ID = '225';
export const TORONTO_LOCATION_ID = '147';
export const MEXICO_CITY_LOCATION_ID = '248';
export const LATAM_LOCATION_ID = '249';

export const LOCATIONS = {
    [KCI_WEB_LOCATION_ID]: {
        netsuiteId: KCI_WEB_LOCATION_ID,
        name: 'Kabbalah Centre International',
        currencies: ['usd'],
    },
    [FORTY_EIGHTH_STREET_LOCATION_ID]: {
        netsuiteId: FORTY_EIGHTH_STREET_LOCATION_ID,
        name: 'Kabbalah Centre New York',
        currencies: ['usd'],
    },
    [MIAMI_LOCATION_ID]: {
        netsuiteId: MIAMI_LOCATION_ID,
        name: 'Kabbalah Centre Florida',
        currencies: ['usd'],
    },
    [LOS_ANGELES_LOCATION_ID]: {
        netsuiteId: LOS_ANGELES_LOCATION_ID,
        name: 'Kabbalah Centre Los Angeles',
        currencies: ['usd'],
    },
    [LONDON_LOCATION_ID]: {
        netsuiteId: LONDON_LOCATION_ID,
        name: 'Kabbalah Centre United Kingdom',
        currencies: ['gbp', 'eur', 'usd'],
    },
    [EUROPE_LOCATION_ID]: {
        netsuiteId: EUROPE_LOCATION_ID,
        name: 'Kabbalah Centre Europe',
        currencies: ['eur', 'gbp', 'usd'],
    },
    [TORONTO_LOCATION_ID]: {
        netsuiteId: TORONTO_LOCATION_ID,
        name: 'Kabbalah Centre Toronto',
        currencies: ['cad'],
    },
    [MEXICO_CITY_LOCATION_ID]: {
        netsuiteId: MEXICO_CITY_LOCATION_ID,
        name: 'Kabbalah Centre Mexico City',
        currencies: ['mxn'],
    },        
    [LATAM_LOCATION_ID]: {
        netsuiteId: LATAM_LOCATION_ID,
        name: 'Kabbalah Centre Latin America',
        currencies: ['mxn'],
    },                           
}


// WEBPACK FOOTER //
// ./src/constants/locations.js